import YaCounter from "../ym";

window.VegasCatalog.Fav = {
	add: function (id, params, callback) {
		params = params || {};
		params.id = id;
		params._token = App.csrf;

		this.addRequest(params, callback);
	},

	addRequest: function (params, callback) {
		$.post('/account/favorites/add_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Fav.total(data);
			VegasCatalog.popup('Добавлено в избранное');
			$('[data-fav][data-counter=products]').data('title', 'Убрать из избранное');

			new YaCounter().goal('add-to-fav');
		});
	},

	remove: function (id, callback) {
		let params = {};
		params.id = id;
		params._token = App.csrf;

		this.removeRequest(params, callback);
	},

	removeRequest: function (params, callback) {
		$.post('/account/favorites/del_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Fav.total(data);
			VegasCatalog.popup('Убрано из избранного');

			$('[data-fav][data-counter=products]').data('title', 'Добавить в избранное');
		});
	},

	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			let $favTool = $('[data-fav][data-counter=products]');

			$favTool.attr('data-cnt', data.products_count);
			$favTool.addClass('active');

			setTimeout(() => {
				$favTool.removeClass('active');
			}, 1000);
		}
	}
};

let $document = $(document);

/** PRODUCT ITEM */
$document.on('click', '[data-product-item] [data-fav][data-action=add]', function () {
	let $product = $(this).closest('[data-product-item]');
	let $btn = $(this);
	let id = $product.data('id');

	$product.addClass('in-fav');
	$btn.attr('data-action', 'del')

	VegasCatalog.Fav.add(id);

	return false;
});

$document.on('click', '[data-product] [data-fav][data-action=add]', function () {
	let $product = $(this).closest('[data-product]');
	let $btn = $(this);
	let id = $product.data('id');

	$product.addClass('in-fav');
	$btn.attr('data-action', 'del')

	VegasCatalog.Fav.add(id);

	return false;
});

$document.on('click', '[data-product-item] [data-fav][data-action=del]', function () {
	let $product = $(this).closest('[data-product-item]');
	let $btn = $(this);
	let id = $product.data('id');

	$product.removeClass('in-fav');
	$btn.attr('data-action', 'add');

	VegasCatalog.Fav.remove(id);

	return false;
});

$document.on('click', '[data-product] [data-fav][data-action=del]', function () {
	let $product = $(this).closest('[data-product]');
	let $btn = $(this);
	let id = $product.data('id');

	$product.removeClass('in-fav');
	$btn.attr('data-action', 'add');

	VegasCatalog.Fav.remove(id);

	return false;
});

/** CART */
$document.on('click', '[data-product-cart-item] [data-fav][data-action=add]', function () {
	let $product = $(this).closest('[data-product-cart-item]');
	let $btn = $(this);
	let id = $product.data('id');

	$btn.attr('data-action', 'del');
	$btn.find('span').text('Убрать из избранного');

	VegasCatalog.Fav.add(id);

	return false;
});

$document.on('click', '[data-product-cart-item] [data-fav][data-action=del]', function () {
	let $product = $(this).closest('[data-product-cart-item]');
	let $btn = $(this);
	let id = $product.data('id');

	$btn.attr('data-action', 'add');
	$btn.find('span').text('Добавить в избранное');

	VegasCatalog.Fav.remove(id);

	return false;
});

/** ACCOUNT FAV LIST */
$document.on('click', '[data-product-fav-item] [data-fav][data-action=del]', function () {
	let $product = $(this).closest('[data-product-fav-item]');
	let id = $product.data('id');

	$product.find('[data-bs-toggle=tooltip]').each(function (i, e) {
		$(e).tooltip('dispose');
	});
	$product.remove();

	VegasCatalog.Fav.remove(id);

	let itemsCount = $('.account-profile--content [data-product-fav-item]').length;
	if (!itemsCount)
		location.reload();

	return false;
});